import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api, { setSedeAttivaHeader } from './api';
import { useAuth } from './auth';

const SedeContext = createContext(null);
const STORAGE_KEY = 'rsa_sede_attiva';

export function SedeProvider({ children }) {
  const { user } = useAuth();
  const [sedi, setSedi] = useState([]);
  const [tutteLeSedi, setTutteLeSedi] = useState(true);
  const [sedeAttiva, setSedeAttivaState] = useState(localStorage.getItem(STORAGE_KEY) || 'tutte');

  const setSedeAttiva = useCallback((value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setSedeAttivaHeader(value);
    setSedeAttivaState(value);
  }, []);

  useEffect(() => {
    if (!user) return;
    api.get('/sedi').then(r => {
      const lista = r.data.sedi || [];
      setSedi(lista);
      setTutteLeSedi(r.data.tutte_le_sedi);
      const salvata = localStorage.getItem(STORAGE_KEY);
      const valida = salvata && (salvata === 'tutte' ? r.data.tutte_le_sedi : lista.some(s => s.id === salvata));
      if (!valida) {
        setSedeAttiva(r.data.tutte_le_sedi ? 'tutte' : (lista[0]?.id || 'tutte'));
      } else {
        setSedeAttivaHeader(salvata);
      }
      const attiva = lista.find(s => s.id === (localStorage.getItem(STORAGE_KEY) || ''));
      localStorage.setItem('rsa_sede_nome', attiva ? attiva.nome : 'Tutte le sedi');
    }).catch(() => {});
  }, [user, setSedeAttiva]);

  useEffect(() => {
    const attiva = sedi.find(s => s.id === sedeAttiva);
    localStorage.setItem('rsa_sede_nome', attiva ? attiva.nome : 'Tutte le sedi');
  }, [sedeAttiva, sedi]);

  const refresh = useCallback(() => {
    api.get('/sedi').then(r => { setSedi(r.data.sedi || []); setTutteLeSedi(r.data.tutte_le_sedi); }).catch(() => {});
  }, []);

  const sedeCorrente = sedi.find(s => s.id === sedeAttiva) || null;

  return (
    <SedeContext.Provider value={{ sedi, sedeAttiva, setSedeAttiva, tutteLeSedi, sedeCorrente, refresh }}>
      {children}
    </SedeContext.Provider>
  );
}

export function useSede() {
  const ctx = useContext(SedeContext);
  if (!ctx) throw new Error('useSede must be used within SedeProvider');
  return ctx;
}
